function toggleColorSwatchesVisibility (productId) {
  const colorSwatches = document.querySelectorAll(`.swatches-product-${productId}`);
  colorSwatches.forEach(function (colorSwatch) {
    colorSwatch.classList.toggle('hide-element');
  });
  const colorSwatchesTogglePlusIcon = document.querySelector(`.plus-icon-${productId}`);
  if (colorSwatchesTogglePlusIcon) {
    colorSwatchesTogglePlusIcon.classList.toggle('hide-element');
  }
  const colorSwatchesToggleMinusIcon = document.querySelector(`.minus-icon-${productId}`);
  if (colorSwatchesToggleMinusIcon) {
    colorSwatchesToggleMinusIcon.classList.toggle('hide-element');
  }
}

function toggleReadMoreLess (toShow, toHide) {
  const descriptionElement = document.querySelector('.product-single__description')
  if (descriptionElement) {
    descriptionElement.classList.toggle('product-single__description--expanded')
  }
  const toShowElement = document.querySelector(toShow)
  const toHideElement = document.querySelector(toHide)
  if (toShowElement) {
    toShowElement.classList.remove('hide-element')
  }
  if (toHideElement) {
    toHideElement.classList.add('hide-element')
  }
}

function scrollToElement (element) {
  const targetElement = document.querySelector(element);
  // Adjust the gap in pixels (e.g., 50 pixels)
  const gap = 200;

  // Set the scrollTop property to scroll with a gap
  if (targetElement) {
    window.scrollTo({
      top: targetElement.offsetTop - gap,
      behavior: "smooth",
    });
  }
}

